/* eslint-disable react/prop-types */
import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const BORDER_COLOR = "#bfbfbf";
const BORDER_STYLE = "solid";
const COL0_WIDTH = 10;
const COLN_WIDTH = (100 - COL0_WIDTH) / 3;
const tableCol = {
  width: COLN_WIDTH + "%",
  borderStyle: BORDER_STYLE,
  borderColor: BORDER_COLOR,
  borderWidth: 1,
  borderLeftWidth: 0,
  borderTopWidth: 0
};
const preSyles = {
  title: {
    margin: 5,
    fontSize: 14,
    fontWeight: 500
  },
  date: {
    margin: 5,
    fontSize: 10
  },
  body: {
    padding: 10
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableColHeader: {
    ...tableCol,
    borderBottomColor: "#000"
  },
  tableCol,
  tableCellHeader: {
    margin: 5,
    fontSize: 10,
    fontWeight: 500
  },
  tableCell: {
    margin: 5,
    fontSize: 8
  }
};
const COLS = [5, 12, 20, 10, 10, 5, 8, 10, 20];
const align = [
  "right",
  "left",
  "left",
  "center",
  "right",
  "center",
  "right",
  "right",
  "left"
];
COLS.map((item, index) => {
  preSyles["tableColHeader" + index] = {
    ...preSyles.tableColHeader,
    width: item + "%",
    textAlign: align[index]
  };
  preSyles["tableCol" + index] = {
    ...preSyles.tableCol,
    width: item + "%",
    textAlign: align[index]
  };
  return item;
});
const styles = StyleSheet.create(preSyles);

class PdfPrintList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "DAFTAR TAGIHAN LISTRIK",
      header: [],
      data: []
    };
  }

  componentDidMount() {
    const data = this.props.data;

    if (data.data && data.footer) {
      const footer = data.footer;
      const rowFooter = {};
      Object.keys(data.data[0]).map((key, index) => {
        rowFooter[key] = footer[index];
        return key;
      });
      data.data.push(rowFooter);
    }

    this.setState({ ...data });
  }

  setData = params => {
    if (params.data && params.footer) {
      const data = params.data;
      const footer = params.footer;
      const rowFooter = {};
      Object.keys(data).map((key, index) => {
        rowFooter[key] = footer[index];
        return key;
      });
      data.push(rowFooter);
      params.data = data;
    }
    this.setState({ ...params });
  };

  render() {
    return (
      <Document>
        <Page style={styles.body}>
          <View style={styles.title}>
            <Text>{this.state.title.toUpperCase()}</Text>
          </View>
          <View style={styles.date}>
            <Text>
              {`Tanggal cetak : ${moment().format(
                "dddd, DD MMMM YYYY HH:mm"
              )}`.toUpperCase()}
            </Text>
          </View>

          <View style={styles.table}>
            {/* Header kolom muncul di setiap halaman */}
            <View style={styles.tableRow} fixed>
              {this.state.header.map((item, index) => (
                <View
                  key={index}
                  style={
                    styles["tableColHeader" + index] ?? styles.tableColHeader
                  }
                >
                  <Text style={styles.tableCellHeader}>{item}</Text>
                </View>
              ))}
            </View>

            {/* react-pdf otomatis handle page break */}
            {this.state.data.map((item, index) => (
              <View key={index} style={styles.tableRow}>
                {Object.keys(item).map((key, idx) => (
                  <View
                    key={idx}
                    style={styles["tableCol" + idx] ?? styles.tableCol}
                  >
                    <Text style={styles.tableCell}>{item[key].toString()}</Text>
                  </View>
                ))}
              </View>
            ))}
          </View>
        </Page>
      </Document>
    );
  }
}

export default PdfPrintList;
